export default __webpack_public_path__ + "static/media/Narf_signature.48be993b.png";